import { Navigate, Outlet } from 'react-router-dom';
import { isPortalAuthenticated } from '../services/portalAuth';

export default function PortalProtectedRoute() {
  return isPortalAuthenticated() ? <Outlet /> : <Navigate to="/portal/login" replace />;
}
